import { render, staticRenderFns } from "./LoginSection.vue?vue&type=template&id=080105bc&scoped=true&"
import script from "./LoginSection.vue?vue&type=script&lang=js&"
export * from "./LoginSection.vue?vue&type=script&lang=js&"
import style0 from "./LoginSection.vue?vue&type=style&index=0&id=080105bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080105bc",
  null
  
)

export default component.exports